@use "../../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../../styles/Constants.scss" as Constants;

.MaterialsTable {
	.cell {
		display: flex;
		flex-direction: column;
		align-items: stretch;
		flex: 1;
		background-color: Colors.$col-design-grey13
	}

	.cellLine {
		display: flex;
		flex-direction: row;
		align-items: stretch;
		justify-content: space-between;
		flex: 1;

		&.inEdit {
			background-color: Colors.$col-white;
		}
	}

	.rateSourceContainer {
		display: flex;
		align-items: center;
		padding-left: Constants.$val-spacing-s;
	}

	.totalCostCell {
		display: flex;
		align-items: center;
		background-color: Colors.$col-white;
		flex: 1;
		justify-content: flex-end;
		padding: 0 Constants.$val-spacing-s;
	}

	.selectCell {
		justify-content: center;
	}

	.inactiveReadonlyField {
		color: Colors.$col-design-grey10;
	}
}
